const { REACT_APP_JAM_SERVER, REACT_APP_JAM_TOKEN } = process.env;

export const JAM_ARGS = {
  serverUrl: REACT_APP_JAM_SERVER!,
  token: REACT_APP_JAM_TOKEN!,
};
